// @flow
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withSubscriptions, getTags } from '@finect/front-core/User';
import type { WithSubscriptionsProps } from '@finect/front-core/User';
import { DatalayerScene } from '@finect/front-gtm';
import { Head } from '@finect/tabular-components/Head';
import { ArticlesFeed } from '../ArticlesFeed';
import { getArticlesFeed, clearArticlesFeed } from '../../../store/articles/actions';

type State = {
  fetching: boolean
};

type Props = {
  user: Object,
  type: 'noticias' | 'a-fondo' | 'en-un-minuto',
  followedTags: Array<string>,
  actions: Object,
  articlesFeed: Object
} & WithSubscriptionsProps;

const mapStateToProps = state => ({
  user: state.user.user,
  followedTags: state.user.subscriptions.tags,
  articlesFeed: state.articles.articlesFeed
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getArticlesFeed,
      clearArticlesFeed,
      getTags
    },
    dispatch
  )
});

const FILTER_BY_TYPE = {
  noticias: `filter=tag+ne+-1`,
  'a-fondo': `filter=tag+ne+6`,
  'en-un-minuto': `filter=tag+eq+6`
};

class Latest extends React.Component<Props, State> {
  static loadInitialData(store: Object, cookies: string, match: Object, params: Object) {
    return store.dispatch(getArticlesFeed(FILTER_BY_TYPE[params.type]));
  }

  state = {
    fetching: false
  };

  loadArticles = (limit: number = 20, offset: number = 0) => {
    this.setState({ fetching: true });
    this.props.actions.getArticlesFeed(FILTER_BY_TYPE[this.props.type], limit, offset).then(() => {
      this.setState({ fetching: false });
    });
  };

  componentDidMount() {
    if (!this.props.followedTags.length) this.props.actions.getTags();

    if (!this.props.articlesFeed.items.length) this.loadArticles();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      Promise.all([this.props.actions.clearArticlesFeed(), this.loadArticles()]);
    }
  }

  componentWillUnmount() {
    this.props.actions.clearArticlesFeed();
  }

  handleMore = () => {
    if (this.state.fetching) return;

    this.loadArticles(10, this.props.articlesFeed.items.length);
  };

  render() {
    const minTablet = typeof window !== 'undefined' ? window.innerWidth >= 800 : false;
    return (
      <>
        <Head
          title="Noticias sobre inversión y finanzas"
          description="Todas las noticias, información y análisis detallados sobre inversión, productos financieros, estrategias, perspectivas, macroeconomía..."
          canonical={`/articulos-financieros/${this.props.type}`}
        />
        <DatalayerScene pageType="articles" pageId={this.props.type} />

        <ArticlesFeed
          type={this.props.type}
          articles={this.props.articlesFeed.items}
          fetching={this.state.fetching}
          handleMore={this.handleMore}
          user={this.props.user}
          followedTags={this.props.followedTags}
          scrollOffset={minTablet ? 600 : 1500}
        />
      </>
    );
  }
}

export default withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(Latest), ['tags']);
